var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-good-table',{attrs:{"mode":"remote","pagination-options":{
      enabled: false,
    },"search-options":{
       enabled: true,
       trigger: 'enter',
    },"rows":_vm.rows,"columns":_vm.columns,"styleClass":"vgt-table text-xs p-1-important table-bordered","row-style-class":_vm.rowStyle,"max-height":(_vm.maxHeight + "px"),"fixed-header":_vm.fixedHeader,"line-numbers":_vm.lineNumbers,"sort-options":{
      enabled: false,
    }},on:{"on-search":_vm.onSearchChange,"on-row-dblclick":function($event){return _vm.$emit('rowDoubleClick')}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_vm._t("row",null,{"row":props})]}}],null,true)},[_c('template',{slot:"table-actions"},[_vm._t("table-actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }